import React from 'react';

const Stats = () => {
  const stats = [
    { value: '24/7', label: 'Disponibilidad' },
    { value: '100%', label: 'Personalizable' },
    { value: 'GDPR', label: 'Compliance' },
    { value: 'Multi', label: 'Idioma' }
  ];

  return (
    <section className="stats-section">
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-value">{stat.value}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
